/** Anzeigename der Anwendung – Browser-Tab, Topbar, Login. */
export const APP_NAME = "Star Tales Admin";

/** Setzt den Tab-Titel als „Seite · Star Tales Admin“. */
export function pageTitle(page?: string): string {
  return page ? `${page} · ${APP_NAME}` : APP_NAME;
}
